export const CHECK_OLD_PASSWORD = 'CHECK_OLD_PASSWORD';
export const CHECK_OLD_PASSWORD_DONE = 'CHECK_OLD_PASSWORD_DONE';
export const CHECK_OLD_PASSWORD_ERROR = 'CHECK_OLD_PASSWORD_ERROR';
export const CHECK_OLD_PASSWORD_RESET = 'CHECK_OLD_PASSWORD_RESET';
//# sourceMappingURL=actionTypes.js.map